module.exports = __webpack_public_path__ + "assets/icons/thumb-up-nonactive.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/thumb-up-nonactive.png
// module id = ./src/styles/icons/emojies/thumb-up-nonactive.png
// module chunks = 0